import React, { useState, useEffect } from 'react';
import { MainDocInput, LabelDocInput, DocInput } from './DocumentInput.style';
import axios from 'axios';


const DocumentInput = (props) => {
  const [ file, setFile ] = useState({});
  
  let fileReader = new FileReader();

  fileReader.onload = (event) => { 
      let objectInfo = JSON.parse(event.target.result);
      setFile(objectInfo);
  };

  function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}

  let readWriteFile = e => {
    
    let fileFormat = {
      userId: props.userId,
      name: props.name,
      data: file
    }

    let url = "https://blooming-spire-64013.herokuapp.com/admin/sendReport"

    let config =  { 
      headers: {
        'Authorization': "bearer " + JSON.parse(localStorage.getItem('token'))
      }
    };

    if(isEmpty(file)){
      props.createNotification('warning-no-document')()
      return;
    } else {
      axios.post(url,
        fileFormat,
        config,
        { withCredentials: true})
        .then(resp => {
          props.createNotification('success', props.name)()
        })
        .catch(err => props.createNotification('error', props.name)())
    }
    
  };

  useEffect(() => {
    // readWriteFile()
  }, [ props, file]);


  return (
    <MainDocInput style={{border: `3px solid ${props.color}`}}>
      <LabelDocInput htmlFor={props.name}>
        {props.name}
        <DocInput type="file" name={props.name} id={props.name} onChange={file => { 
          if(!file.target.files[0]) return
          if(props.name !== file.target.files[0].name.split('.')[0]){
            props.createNotification('warning', file.target.files[0].name.split('.')[0])()
            // return
          }
          fileReader.readAsText(file.target.files[0]);
          }}/>
          <button onClick={readWriteFile}>Enviar</button>
      </LabelDocInput>
      
    </MainDocInput>
  );
}

export default DocumentInput;
